import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';

import {FORM_ADD_ON_ID} from './consts';
import type {CustomAddOn} from './custom-add-on-select-modal';

type Props = {
    addOnType: CustomAddOn;
    name: string;
    value: string;
};

/**
 * This is used to render a custom add-on placeholder in the Bee editor. We render it as a string
 * using ReactDOMServer, and styles must be applied in-line to work!
 */
export function CustomAddOnPlaceholder(props: Props) {
    let addOnPlaceholder;
    if (props.addOnType === FORM_ADD_ON_ID) {
        addOnPlaceholder = <Illustration src='forms-add-on-placeholder' />;
    } else {
        addOnPlaceholder = <Illustration src='scheduler-add-on-placeholder' />;
    }

    return (
        <div className={props.addOnType} id={props.value} style={{width: '60%', margin: 'auto'}}>
            <h2>{props.name}</h2>
            <div
                style={{
                    maxWidth: '500px',
                    width: '100%',
                    paddingBottom: '20px',
                    margin: 'auto',
                    color: colors.grey,
                }}
            >
                {addOnPlaceholder}
            </div>
        </div>
    );
}
